import React, { useState } from 'react';
import { Toaster } from 'sonner';
import Header from './Header';
import Hero from './Hero';
import Features from './Features';
import Comparison from './Comparison';
import Statistics from './Statistics';
import Pricing from './Pricing';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import Contact from './Contact';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import DemoModal from './DemoModal';

const LandingPage = () => {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  const openDemoModal = () => setIsDemoModalOpen(true);
  const closeDemoModal = () => setIsDemoModalOpen(false);

  return (
    <div className="min-h-screen bg-[#0D0B09]">
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#1F1914',
            border: '1px solid rgba(201, 169, 123, 0.2)',
            color: '#F5F0E8',
          },
        }}
      />
      
      <Header onDemoClick={openDemoModal} />
      <Hero />
      <Features />
      <Comparison />
      <Statistics />
      <Pricing onDemoClick={openDemoModal} />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <DemoModal isOpen={isDemoModalOpen} onClose={closeDemoModal} />
    </div>
  );
};

export default LandingPage;
